import { render, staticRenderFns } from "./TechnicianWorkReport.vue?vue&type=template&id=055516c2&scoped=true&"
import script from "./TechnicianWorkReport.vue?vue&type=script&lang=js&"
export * from "./TechnicianWorkReport.vue?vue&type=script&lang=js&"
import style0 from "./TechnicianWorkReport.vue?vue&type=style&index=0&id=055516c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055516c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VIcon,VSimpleTable})
